import React, { FunctionComponent, useCallback } from 'react';

import { Button } from '@yandex-360/orb-components/dist/components/Button';
import { Empty } from '@yandex-360/orb-components/dist/components/Empty';

import { i18n } from '../../../../../../../helpers/i18n';
import { useActions } from '../../../../../../../hooks';
import { toPassport as toPassportAction } from '../../../../../../user';
import { Island } from '../../../island';
import css from './styles.css';

export const AccountStub: FunctionComponent = () => {
    const { toPassport } = useActions({ toPassport: toPassportAction });

    const onLogInClick = useCallback(() => toPassport(), [toPassport]);

    return (
        <Island className={css.stubWrapper}>
            <Empty
                button={
                    <Button testId="sign-in-button" view="neutral" size="md" onPress={onLogInClick}>
                        {i18n('settings-v2', 'account-log-in')}
                    </Button>
                }
                title={i18n('settings-v2', 'account-stub-title')}
            />
        </Island>
    );
};
